import { pick } from 'lodash';

export const transformExtraChargesList = (item) => {
  const keys = [
    'created_at',
    'data_type',
    'deleted_at',
    'description',
    'group',
    'is_enabled',
    'key',
    'name',
    'updated_at',
    'uuid',
    'value',
    'vendor_uuid',
  ];

  const $item = {
    ...item?.attributes,
  };

  return pick($item, keys);
};

export const transformGetDiscountsList = (item) => {
  const keys = [
    'created_at',
    'data_type',
    'deleted_at',
    'description',
    'group',
    'is_enabled',
    'key',
    'name',
    'updated_at',
    'uuid',
    'value',
    'vendor_uuid',
  ];

  const $item = {
    ...item?.attributes,
  };

  return pick($item, keys);
};

export const transformGetTaxChargesList = (item) => {
  const keys = [
    'created_at',
    'data_type',
    'deleted_at',
    'description',
    'group',
    'is_enabled',
    'key',
    'name',
    'updated_at',
    'uuid',
    'value',
    'add_vat',
    'vendor_uuid',
  ];

  const $item = {
    ...item?.attributes,
    value: item?.attributes?.value?.value * 100,
    add_vat: item?.attributes?.value?.addVat,
  };

  return pick($item, keys);
};

export const transformGetVAT = (item) => {
  const keys = ['name', 'key', 'description', 'group', 'data_type', 'value'];

  const $item = {
    ...item?.attributes,
    value: {
      ...item?.value,
      value: item?.value?.value * 100,
    },
  };

  return pick($item, keys);
};

export const transformUpdateExtraChargesPayload = (payload) => {
  const $payload = payload?.list?.map((item) => ({
    name: item?.name,
    key: item?.key ?? (item?.name || '').toLowerCase()?.replaceAll(' ', '-'),
    description: item?.description,
    data_type: item?.data_type ?? 'price',
    value: parseFloat(item?.value),
  }));

  return $payload;
};

export const transformCreateDiscount = (payload) => {
  const $payload = {
    description: 'A discount for senior citizens',
    group: 'DISCOUNTS',
    data_type: 'price',
    key: (payload?.name || '').toLowerCase()?.replaceAll(' ', '-'),
    name: payload?.name,
    value: parseFloat(payload?.value),
  };

  return $payload;
};

export const transformVATPayload = (payload) => {
  const name = payload?.name ?? 'Value Added Tax';

  const $payload = {
    name,
    key: name.toLowerCase()?.replaceAll(' ', '-'),
    description: 'A discount for senior citizens',
    group: 'TAX_CHARGES',
    data_type: 'object',
    value: {
      addVat: payload?.add_vat,
      value: payload?.value / 100,
    },
  };

  return $payload;
};
